import { ColumnType } from "@mondaydotcomorg/api";

export const MONDAY_SCHEMAS = {
	base: `
        id
        text
        type
    `,
	assets: `
    assets {
        id
        public_url
        name
    }`,
	[ColumnType.Status]: `
    ... on StatusValue  {
        label_style {
            color
        }
    }`,
	[ColumnType.File]: `
    ... on FileValue {
        files {
            ... on FileAssetValue {
                asset_id
            }
        }
    }`,
	[ColumnType.Mirror]: `
    ... on MirrorValue {
        display_value
    }`,
	[ColumnType.Date]: "",
	[ColumnType.Dropdown]: `
    ... on DropdownValue {
        values { 
            label 
            id
        }
    }`,
	[ColumnType.Timeline]: `
    ... on TimelineValue {
        to
        from
    }`,
	[ColumnType.Email]: `
    ... on EmailValue {
        email
    }`,
	[ColumnType.Formula]: `
    ... on FormulaValue {
        display_value
    }`,
	[ColumnType.Checkbox]: "",
};

export type MONDAY_TYPES = {
	base: { id: string; name: string };
	assets: { assets: { id: string; public_url: string; name: string }[] };
	[ColumnType.File]: { url: string; name: string; id: string }[];
	[ColumnType.Status]: { label: string; color: string };
	[ColumnType.Text]: string;
	[ColumnType.Mirror]: string;
	[ColumnType.Date]: string;
	[ColumnType.Dropdown]: Array<{ label: string; id: string }>;
	[ColumnType.Timeline]: { from: string; to: string };
	[ColumnType.Checkbox]: boolean;
	[ColumnType.Email]: string;
	[ColumnType.Formula]: string | null;
};

const { assets, ...ALL_SCHEMAS } = MONDAY_SCHEMAS;

export const ALL_MONDAY_SCHEMAS = Object.values(ALL_SCHEMAS).join(`
`);

export function MONDAY_PAGINATED_PARAMS_DEF(
	cursor: string | undefined,
	ifNoCursor?: string,
) {
	return `
        $limit: Int,
        ${cursor ? "$cursor: String!" : ifNoCursor || ""}`;
}

export function MONDAY_PAGINATED_PARAMS_USE(
	cursor: string | undefined,
	ifNoCursor?: string,
) {
	return `
        limit: $limit,
        ${cursor ? "cursor: $cursor" : ifNoCursor || ""}`;
}
